import React from 'react'
const DefaultView = ()=>{
return(
    <div className=' d-flex flex-column align-items-center justify-content-center' style={{minHeight:'212px'}} >
           <span className=" d-flex align-items-center justify-content-center"style={{fontSize:'70px',color:'#E2E2E2',backgroundColor:'#F5F5F5',border:'1px',  borderRadius:'50%', width:'100px', height:'100px'}}>₹</span>
           <div className='mt-2' style={{fontWeight:400, fontSize:'16px', lineHeight:'24px'}}>Select payment mode to add details</div>
    </div>
)}
export default DefaultView